export default __webpack_public_path__ + "static/media/goldLine.977a77e8.svg";